import { createSlice } from '@reduxjs/toolkit';

const initialState={
  actual: 0,
  total:0
};
export const pagSlice = createSlice({
  name: 'pag',
  initialState,
  reducers: {
    inicpag: (state) => {
      state.actual= 0;
    },
    actpag: (state) => {
      state.actual+= 1;
    },
    acttotpag: (state,action) => {
      state.total=action.payload;
    },    
  },
});
export const { inicpag, actpag, acttotpag } = pagSlice.actions;
export const pagact=(state)=>state.pag.actual;
export const pagtot=(state)=>state.pag.total;
export default pagSlice.reducer;
